import Vue, { VNode, VueConstructor } from 'vue';
import i18n from '../../locales/i18n';
import { iconClassEnum } from '../../enums/iconClassEnum';
import { InstitutionProfileModel } from '../../models/institutionProfile.model';
import uniqueId from 'lodash/uniqueId';

export type ToastVariant = 'primary' | 'error';

const plugin = {
  install(vueApp: VueConstructor) {
    vueApp.prototype.$confirmAction = function (message: VNode[] | string): Promise<boolean | null> {
      if (!this.$bvModal) {
        return Promise.resolve(false);
      }

      const iconClose = `<i class="${iconClassEnum.CLOSE}"></i>`;

      return this.$bvModal.msgBoxConfirm(message, {
        size: 'sm',
        modalClass: 'modal-warning',
        okVariant: 'primary',
        cancelVariant: 'link',
        title: i18n.t('label.warning'),
        okTitle: i18n.t('button.yes'),
        cancelTitle: i18n.t('button.cancel'),
        hideHeaderClose: false,
        headerCloseContent: iconClose,
      });
    };
    vueApp.prototype.$showToast = function (message: VNode[] | string, variant: ToastVariant = 'primary'): void {
      if (!this.$root?.$bvToast) {
        return;
      }

      const h = this.$createElement;
      const id = uniqueId('toastr');
      const vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline'] }, [
        h(
          'b-button',
          {
            class: 'close',
            attrs: { variant: 'link' },
            on: { click: () => this.$bvToast.hide(id) },
          },
          [h('i', { class: 'icon-Aula_close' }, '')]
        ),
      ]);

      this.$root.$bvToast.toast(message, {
        id,
        title: [vNodesTitle],
        noCloseButton: true,
        solid: true,
        autoHideDelay: 3000,
        variant,
      });
    };
    vueApp.prototype.$getProfileDisplayName = function (institutionProfile: InstitutionProfileModel): string {
      const names = [];
      if (institutionProfile.fullName != null) {
        names.push(institutionProfile.fullName);
      } else if (institutionProfile.name != null) {
        names.push(institutionProfile.name);
      } else {
        names.push(institutionProfile.firstName, institutionProfile.lastName);
      }
      let displayName = names.join(' ');
      if (institutionProfile.alias) {
        displayName += Vue.prototype.$getText('ALIAS');
      }
      if (institutionProfile.metadata) {
        displayName += ' (' + institutionProfile.metadata + ')';
      }
      return displayName;
    };
  },
};
export default plugin;
